import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    cta: 'Continue',
    headerDescription:
      'Based on the information you provided, we need you to add these additional documents. Feel free to do it now or come back whenever you want.',
    problemWithDocs: 'There was an issue with some of your documents:',
    title: 'My Micro-Entreprise',
  },
  fr: {
    cta: 'Continuer',
    headerDescription:
      'Compte tenu des informations que vous avez renseignées, nous avons besoin des documents suivants pour compléter votre dossier. Vous pouvez les ajouter maintenant, ou revenir à tout moment.',
    problemWithDocs: 'Certains documents ont été refusés',
    title: 'Ma micro-entreprise',
  },
} as const);
